(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cgx-custom-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var sets = root.querySelectorAll('[data-ex]');
    if (root.__cgxTimer) clearInterval(root.__cgxTimer);
    if (sets.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    root.__cgxTimer = setInterval(function () {
      sets[i].classList.remove('is-on');
      i = (i + 1) % sets.length;
      sets[i].classList.add('is-on');
    }, root.classList.contains('cgx-cc--photos') ? 2400 : 2600);
  }
  function bar(scope) {
    (scope || document).querySelectorAll('[data-cgx-hero-bar]').forEach(function (b) {
      var sec = b.closest('section'); var cta = sec && sec.querySelector('[data-cgx-hero-cta]');
      if (!cta || !('IntersectionObserver' in window)) return;
      var btn = b.querySelector('a');
      new IntersectionObserver(function (es) {
        var on = es[0].intersectionRatio < 0.98;
        b.classList.toggle('is-on', on); b.setAttribute('aria-hidden', on ? 'false' : 'true'); if (btn) btn.tabIndex = on ? 0 : -1;
      }, { threshold: [0, 0.98, 1] }).observe(cta);
    });
  }
  function all(scope) { (scope || document).querySelectorAll('[data-cgx-cc]').forEach(init); bar(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var set = e.target.closest && e.target.closest('[data-ex]');
    if (!set && e.target.matches && e.target.matches('[data-ex]')) set = e.target;
    if (!set) return;
    var root = set.closest('[data-cgx-cc]');
    if (root.__cgxTimer) clearInterval(root.__cgxTimer);
    root.querySelectorAll('[data-ex]').forEach(function (s) { s.classList.toggle('is-on', s === set); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
